import { formatDate } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

// libs
import {NgbDate, NgbCalendar, NgbDatepicker, NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';

// interfaces
import { Inavigation } from 'src/app/core/interfaces/inavigation';
import { IBillInfo } from 'src/app/core/interfaces/ads/ads-bill-info';
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';
import { IMetaDataBooking } from 'src/app/core/interfaces/payment/meta-data-booking';

// services
import { GlobleService } from 'src/app/core/services/globle.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

// enums
import { PRODUCT_TYPE } from 'src/app/core/enums/ads/ads-types';
import { Rent_Type } from 'src/app/core/enums/ads/rent-types';
import { BILL_TYPE } from 'src/app/core/enums/ads/bill/bill-type';
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';
import { PAYMENT_TYPE } from 'src/app/core/enums/payment/payment-types';
import { LAYOUTS_TYPE } from 'src/app/core/enums/layouts/layouts-types';
import { AlertService } from 'src/app/core/services/alert/alert.service';
import { PAYMENT_AUTH_RES } from 'src/app/core/enums/payment/authorize-response';
import { PAYMENT_TERMS_TYPE } from 'src/app/core/enums/payment/payment-terms-type';

// reusable
import { listOfMonthsAr, listOfWeekDaysAr } from 'src/app/core/reusable-objects/date/calender-ar';

// funcations helper
import MillisecondsToDay from 'src/app/core/funcations-helper/Date/milliseconds-to-day';

@Component({
  selector: 'app-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.scss']
})
export class BookingsComponent implements OnInit {

  @ViewChild('dp', {static: true}) datepicker: NgbDatepicker;

  // init props
  billInfo: IBillInfo
  FormBooking: UntypedFormGroup
  navigation!: Inavigation  
  isloading: boolean = false
  metaData: IMetaDataBooking
  showTerms: boolean = false
  openPayment: boolean = false
  acceptTerms: boolean = false
  alertSuccess: boolean = false

  // NgbDate
  days: number = 0
  DATE = new Date();
  fromDate: NgbDate | null;
  minDate = {
    day: this.DATE.getDate(),
    year: this.DATE.getFullYear(),
    month: this.DATE.getMonth() + 1
  }
  isDisabled: any;
  toDate: NgbDate | null = null;
  hoveredDate: NgbDate | null = null; 

  // number & string
  Id: string

  // obj
  infoAds: IAdvertisementResponse
  bookingResponse: {[key: string]: any}

  // enums
  ads_type = PRODUCT_TYPE
  payment_type = PAYMENT_TYPE
  PAYMENT_TERMS_TYPE = PAYMENT_TERMS_TYPE

  // array
  errorMsg: any[] = []
  notAllowedBookings: string[] = [];
  listOfRentType = [
    {name: 'اليومي', id: Rent_Type.DY},
  ]

  constructor(
    private FB: UntypedFormBuilder,
    private G: GlobleService,
    private Alert: AlertService,
    private route: ActivatedRoute,
    private API_RESPONSE: ApiResponseService,

    // public
    public calendar: NgbCalendar,
    public i18n: NgbDatepickerI18n
  ) {}

  ngOnInit(): void {

    // set
    this.Id = this.route.snapshot.params['id']
    
    this.API_RESPONSE.getBookingCalendar(this.Id, {
      params: {
        startDate: new Date().toJSON()
      }
    }).subscribe((res: string[]) => {
      
      //
      let f = res.map(d => d?.split('T')[0]);
      
      //
      this.notAllowedBookings = f;
      
      //
      this.isDisabled = (date: NgbDate, current: {month: number}) => {
        let similarDate = `${date.year}-${date.month}-${date.day}`;
        return f.includes(similarDate)
      }

    })

    this.navigation = {
      label: 'حجوزات',
      path: `/realty-management/view-realty-advertisement/${this.Id}`,
    }

    this.FormBooking = this.FB.group({
      type: ['INSIDE'],
      endDate: [null],
      durationType: [Rent_Type.DY],
      startDate: [null, Validators.required],
    })

    // call api
    this.requestInfoAds();

  }

  requestInfoAds() {
    
    // connect with server once
    this.route.data.subscribe(
      (res: any) => this.infoAds = res?.ads,
      err => this.G.navigate(['/'])
    )
    
  }

  bill() {

    this.isloading = true

    this.API_RESPONSE.getBillInfo({
      data: { 
        ads: this.Id,
        days: this.days,
        billType: BILL_TYPE.rent
      },
      params: {
        [RANDOM_VALUE.loader]: true
      }
    }).subscribe(
      res => {
        this.billInfo = res
        this.isloading = false
      },
      err => this.isloading = false
    ) 
   
  }

  // *** start ngb-datepicker *** //

    onDateSelection(date: NgbDate) {
      if (!this.fromDate && !this.toDate) {
        this.fromDate = date;
      } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
        this.toDate = date;
      } else {
        this.toDate = null;
        this.fromDate = date;
        this.control('endDate')?.reset()
      }
      
      this.rangeManagement()

    }

    public navigate(number: number) {
      const {state, calendar} = this.datepicker;
      this.datepicker.navigateTo(calendar.getNext(state.firstDate, 'm', number));
    }

    public getDay(date: any) {
      
      // ES6 Destructuring
      const { year, month, day } = date || {};

      let d = new Date(`${year}/${month}/${day}`);

      return listOfWeekDaysAr[d.getDay()]

    }

    public getMonth(date: any) {
      // ES6 Destructuring
      const { year, month, day } = date || {};

      let d = new Date(`${year}/${month}/${day}`);

      return listOfMonthsAr[d.getMonth()]

    }

    rangeManagement() {
      
      // format Dates
      const fromDate = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
      const toDate = this.toDate ? `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}` : fromDate;

      // like 16823827382832
      let formatDateToTimes = this.notAllowedBookings.map(d => new Date(d).getTime());


      const reservedDate = formatDateToTimes.find(d => {

        if (d > new Date(fromDate).getTime() && d < new Date(toDate).getTime()) return new Date(d)

        return null

      })

      if (reservedDate) this.FormBooking.setErrors({rangeNotValid: true})
      else {
        // update Form
        this.FormBooking.setErrors({rangeNotValid: null})
        this.FormBooking.updateValueAndValidity()

        // set control value
        this.control('endDate')?.setValue(toDate)
        this.control('startDate')?.setValue(fromDate)

        //
        this.days = MillisecondsToDay(new Date(toDate).getTime() - new Date(fromDate).getTime()) + 1
      }
      
      //
      this.bill()
      
      this.FormBooking.markAsTouched()

      
    }

    isHovered(date: NgbDate) {
      return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
    }

    isInside(date: NgbDate) {
      return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
    }

    isRange(date: NgbDate) {
      return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
    }

  // *** end ngb-datepicker *** //

  // *** start  FormGroup *** //

    control(controlName: string) {
      return this.FormBooking.get(controlName)
    }

    alertSubmit() {

      this.alertSuccess = false
      
      this.metaData = {
        client: 0,
        adsId: this.Id,
        tax: this.billInfo?.tax,
        cost: this.billInfo?.cost,
        durationType: Rent_Type.DY,
        type: PAYMENT_TYPE.booking,
        total: this.billInfo?.total,
        bookingId: this.bookingResponse?.id,
        description: 'لكي يتم انشاء حجز يتم دفع سعر الحجز حسب الايام المحجوزة'
      }      
      
      // open payment
      this.openPayment = true      

      // this.G.navigate(['/realty-management/view-realty-advertisement/', this.Id])
    }

    paymentCallback(res: any) {
    
      // ES6 Destructuring
      const { status, metadata } = res || {};
      
      if (status == PAYMENT_AUTH_RES.captured) {
        this.Alert.show({
          titleBtn: 'موافق',
          msg: 'تم الحجز بشكل ناجح',
          callback: () => {
            this.Alert.hide()
          }
        })
      }
      else {
        this.Alert.show({
          titleBtn: 'موافق',
          type: LAYOUTS_TYPE.alertFailure,
          msg: 'لم يتم الحجز بشكل ناجح!',
          callback: () => {
            this.Alert.hide()
          }
        }) 
      }
      
    }     

    submit() {

      if(this.FormBooking.valid) {
        
        const { startDate, endDate } = this.FormBooking.value;

        const start = formatDate(startDate, 'yyyy-MM-dd', 'en-US') + 'T23:59:00.000Z'
        const end = endDate ? formatDate(endDate, 'yyyy-MM-dd', 'en-US') + 'T23:59:00.000Z' : start
        
        const formDate = {
          ...this.FormBooking.value,
          endDate: end,
          startDate: start,
        }

        this.API_RESPONSE.postAddBooking(this.Id, formDate).subscribe(
          res => {
            this.alertSuccess = true
            this.bookingResponse = res;

            //
            this.errorMsg = []
          },
          err => {

            // ES6 Destructuring
            const { errors } = err?.error;

            this.errorMsg = errors;

            this.toDate = null
            this.fromDate = null
            this.control('endDate')?.reset()
            this.control('startDate')?.reset()
            
          }
        )
      }
    }

  // *** end  FormGroup *** //

}
